import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { VatCode } from '@/models/accounting/VatCode'

export default new CachedResourceStore<VatCode>(VatCode, {
	namespaced: true
})
